import { useIntl } from '@weenat/wintl';
import isNil from 'lodash-es/isNil';
import { useClient } from '../ClientProvider';
import { InvitationStatus } from '../enums';
import useMutation from '../useMutation';
export const useInvitationActions = ({ invitation, copyHandler, shouldRestrictSeeAction = false, onCancelSuccess, onDeleteSuccess }) => {
    const client = useClient();
    const { t } = useIntl();
    const [cancelInvitation, cancelInvitationState] = useMutation(client.invitations.sent.cancel(invitation?.id), { onSuccess: onCancelSuccess });
    const [deleteInvitation, deleteInvitationState] = useMutation(client.invitations.deletion(invitation?.id), { onSuccess: onDeleteSuccess });
    if (isNil(invitation)) {
        return [];
    }
    else {
        const actions = [];
        if (!shouldRestrictSeeAction) {
            actions.push({
                id: 'view',
                label: t('models.invitation.misc.see'),
                to: `${invitation.id}`,
                iconName: 'Preview'
            });
        }
        if (invitation.status === InvitationStatus.pending ||
            invitation.status === InvitationStatus.duplicated) {
            actions.push({
                id: 'copy',
                label: t('models.invitation.misc.copy'),
                onPress: () => copyHandler(invitation.acceptUrl),
                iconName: 'Copy'
            });
            actions.push({
                id: 'cancel',
                label: t('models.invitation.misc.cancel'),
                onPress: () => cancelInvitation(),
                state: cancelInvitationState,
                iconName: 'Cancel'
            });
        }
        actions.push({
            id: 'hide',
            label: t('models.invitation.misc.hide'),
            onPress: () => deleteInvitation(),
            state: deleteInvitationState,
            iconName: 'Bin'
        });
        return actions;
    }
};
